module.exports = __webpack_public_path__ + "img/CryptoPack_(M)-min.png";